// eslint-disable-next-line import/prefer-default-export
export const all = state => state.all;
